// extracted by mini-css-extract-plugin
export var gradient = "main-banner-list-block-module--gradient--3dc02";